import styled from '@emotion/styled'
import React, { useEffect, useState,useContext } from 'react'
import { useDispatch } from 'react-redux';
import {FaGlobeAmericas as TopIcon} from 'react-icons/fa';
import { Button, FilterDropDown, SearchForm,option1 } from '../../../../ui-components';
import {BsChevronLeft as LeftIcon,BsChevronRight as RightIcon} from 'react-icons/bs';
import apiCall from '../../../../utils/apiCall';
import { apiRequest } from '../../../../api';
import { NotificationContext } from '../../../../providers/notification';
import { useSettingModal } from '../../../../hooks/Context';
import { FetchSingleData } from '../../../../hooks/FetchData';
import { CircularProgress } from '@mui/material';
import { AxiosError } from 'axios';
import BatchInviteTable from './BatchInvitesTable';
import {AiOutlineSearch as SearchIcon} from 'react-icons/ai';
import {IoReload as ReloadIcon} from 'react-icons/io5';
import styles from '../../Applicants/css/display-applicant.module.css';
import { ExNyRoute } from '../../../../utils/allRouteId';
import { setAllBatchInvite } from '../../../../reduxSlice/batchInviteSlice';




interface TrainingInvites {
    ApplicantId: string;
    ApplicantName: string;
    ApplicantEmail: string;
    ApplicantPhone: string;
  }

  interface BatchInviteProps {
    data: TrainingInvites[],
    handleBatchInviteSubmit: (e:any)=> void
    isLoading: boolean;
  }

const BatchInvites = ({data, handleBatchInviteSubmit, isLoading}: BatchInviteProps) => {
    const [searchData, setSearchData] = useState('');

    const filteredData = data?.filter(x => (
        Object.values(x).join(" ").toLowerCase().includes(searchData.toLowerCase())
    ));

  return (
    <Wrapper>
        <div className='first-div'>
        </div>
        <div className='filter-div'>
        </div>
        {
            <BatchInviteTable setSearchData ={setSearchData} searchData={searchData} data = {searchData.length > 0 ? filteredData : data}/>
        }

        <div>
            <MessageForm onSubmit={handleBatchInviteSubmit}>
                <div>
                    <Button bg="#5BC065" border="#5BC065" style={{padding:'13px 20px'}}>
                        {!isLoading?'Send Invites':'Loading...'}
                    </Button>

                </div>
            </MessageForm>
        </div>
        
    </Wrapper>
  )
}

export default BatchInvites;

const StyledError = styled('p')`
  color: red;
  font-size: 1.4rem;
  display: flex;
`

const NoResult = styled('div')`
  margin-block-start: 10px;
  margin-block-end: 200px;
`


const Wrapper = styled.div`
    border-radius: 10px;
    background-color:var(--white-color);
    display: grid;
    grid-template-columns: 1fr;
    & > .first-div{
        display:flex;
    }
    & > .first-div > span{
        width:50px;
        height:50px;
        display: flex;
        justify-content:center;
        align-items:center;
        background-color:#FFF4DE;
        color:#FEB930;
    }
    & > .filter-div{
        display:flex;
        flex-direction:column;
        gap:10px;
        
    }
    & > .filter-div > div:first-of-type{
        font-size:18px;
        font-weight:bold;
    }
    & > .filter-div > div:nth-of-type(2){
        display:flex;
        gap:15px;
    }
    & > .table-div{
        display:flex;
        flex-direction:column;
        gap:5px;
        margin-top:10px;
    }
    & > .table-div > div{
        width:100%;
    }
    & .t-head{
        display:grid;
        grid-template-columns:repeat(4,1fr);
        background-color:#E0FAEE;
        padding:15px 10px;
    }

    
`


const PageDiv = styled.div`
    padding:10px 30px;
    display: flex;
    justify-content:flex-end;
    align-items:center;
    position:relative;
    & > div{
        position:relative;
        display: flex;
        align-items: center;
    }
    & > div > div{
        display:flex;
        gap:5px;
        flex-wrap:wrap;
        width:fit-content;
        align-items:center;
    }
    & > div > span{
        position: absolute;
        top:0px;
        cursor:pointer;
    }
    & > div > span:first-of-type{
        left:-30px;
    }
    & > div > span:last-of-type{
        right:-30px;
    }
    & > div > div > span{
        width:fit-content;
        padding:3px 5px;
        display:flex;
        justify-content:center;
        align-items:center;
        height:20px;
        border-radius:3px;
        cursor:pointer;
    }
    & > div > div > span.active{
        color:#fff;
        background-color: #11643C;
    }

`
const MessageForm = styled.form`
    display: flex;
    margin-bottom: 20px;
    flex-direction: column;
    justify-content: center;
    & > label{
        display: flex;
        flex-direction: column;
        gap:10px;
    }
    & > label > span{
        font-size:18px;
        font-weight: bold;
        width:fit-content;
    }
    & > label > span::after{
        content:'*';
        color:red;
        display: inline-block;
        
    }
    & textarea{
        resize: vertical;
        outline:none;
        padding:10px;
        border-radius: 6px;
        
    }
    & >div{
        width:100%;
        text-align:center;
        margin-top:20px;
    }
`